// src/features/reports/components/Reports/components/Pagination.jsx
import React from 'react';
import styles from '../Reports.module.css';
import { PAGE_SIZE } from '../hooks/useReportsData';

export default function Pagination({ total, page, onPage }) {
  const totalPages = Math.ceil(total / PAGE_SIZE);
  if (totalPages <= 1) return null;

  const start = (page - 1) * PAGE_SIZE + 1;
  const end   = Math.min(page * PAGE_SIZE, total);

  // بناء أرقام الصفحات مع ...
  const pages = [];
  const left  = Math.max(2, page - 2);
  const right = Math.min(totalPages - 1, page + 2);
  pages.push(1);
  if (left > 2)           pages.push('…');
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < totalPages - 1) pages.push('…');
  if (totalPages > 1)     pages.push(totalPages);

  return (
    <div className={styles.pagination}>
      <span className={styles.pgInfo}>{start}–{end} من {total}</span>
      <div className={styles.pgControls}>
        <button
          className={styles.pgBtn}
          onClick={() => onPage(page - 1)}
          disabled={page === 1}
        >›</button>

        {pages.map((p, i) =>
          p === '…'
            ? <span key={`d${i}`} className={styles.pgDots}>…</span>
            : <button
                key={p}
                className={`${styles.pgBtn} ${p === page ? styles.pgActive : ''}`}
                onClick={() => onPage(p)}
              >{p}</button>
        )}

        <button
          className={styles.pgBtn}
          onClick={() => onPage(page + 1)}
          disabled={page === totalPages}
        >‹</button>
      </div>
    </div>
  );
}